import { render, staticRenderFns } from "./PartnersView.vue?vue&type=template&id=6df04492"
import script from "./PartnersView.vue?vue&type=script&lang=js"
export * from "./PartnersView.vue?vue&type=script&lang=js"
import style0 from "./PartnersView.vue?vue&type=style&index=0&id=6df04492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports